import { Component, OnInit } from '@angular/core';
import { NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';
import { SecurityService } from 'saker-core';
import { Router, NavigationEnd, ActivationEnd } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'DSMAppLocal';

  constructor(
    public security: SecurityService,
    ngbTooltipConfig: NgbTooltipConfig,
    private router: Router
  ) {
    //-------------------------------
    // Global Default
    //-------------------------------
    ngbTooltipConfig.openDelay = 1000 // delay tooltip opening to 1 second
  }

  isMenuCollapsed = false;

  isAuthenticated = this.security.context != undefined;
  showBannerContent = false;

  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        
        const pathsHideBannerContent = ['/splash','/unauthorised']

        if (pathsHideBannerContent.indexOf(event.urlAfterRedirects) > -1){
          this.showBannerContent = false;
          //console.info("SAKER: RouteEvent. " + event.urlAfterRedirects);
        }
        else{
          this.showBannerContent = true;
          //console.info("SAKER: RouteEvent. " + event.toString());
        }
      }
      /*if (event instanceof ActivationEnd) {
        //Can access ActivatedRouteSnapshot here.
      }*/
    });
  }
}
